import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import FAQAccordion from "@/sections/FAQAccordion";
import ContactSection from "@/sections/ContactSection";
import { FAQS } from "@/data/site";

const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question", name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQPage() {
  return (
    <>
      <SEO
        title="FAQ — Frequently Asked Questions"
        description="Answers to common questions about DiziTeQ's digital marketing services, timelines, pricing, Local SEO and ongoing support in Bengaluru."
        path="/faq"
        schema={schema}
      />
      <PageHeader
        eyebrow="FAQ"
        title="Answers to your"
        highlight="questions"
        subtitle="Everything you need to know before partnering with DiziTeQ. Still unsure? Just reach out."
      />
      <FAQAccordion showHeader={false} />
      <ContactSection showMap={false} />
    </>
  );
}
